import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Function to merge two strings together (for tailwind classes).
 *
 * @param inputs input arguments (strings)
 * @returns the final string with all tailwind classes combined
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
